import { FC, Key, useRef } from "react"

import { Button } from "antd"

import { Table } from "@/components/_Shared/Table"
import { EmployeeAddForm, EmployeeAddFormProps } from "@/components/Employees/EmployeeAddForm"
import { UserChangePasswordForm, UserChangePasswordFormProps } from "@/components/Users/UserChangePassword"
import { Resource, Scope } from "@/constants/permission"
import { EMPLOYEE_QUERY_KEY } from "@/constants/query"

import { employeesColumns } from "./EmployeesColumns"
import { useUsersFilters } from "../User/UsersFilters"

import { useEmployeeMutation } from "@/hook/Dictionaries/useEmployeeMutation"
import { useEmployeesQuery } from "@/hook/Dictionaries/useEmployeeQuery"
import { usePermission } from "@/hook/usePermission"
import { useTable } from "@/hook/useTable"

import { IEmployee } from "@/types/Employee/IEmployee"

import { getInitialColumns } from "@/utils/getInitialColumns"


const initialColumns = getInitialColumns(employeesColumns, EMPLOYEE_QUERY_KEY)

const EmployeesPage: FC = () => {
    const employeeComponent = useRef<EmployeeAddFormProps>(null)
    const userChangePasswordComponent = useRef<UserChangePasswordFormProps>(null)

    const { deleteMutation } = useEmployeeMutation()

    const { hasPermission } = usePermission()

    const addChangePassButtonCol = [{
        title: "Действие",
        dataIndex: "changePassword",
        key: "changePassword",
        render: (_: any, employee: IEmployee) => <Button type="primary" onClick={() => {userChangePasswordComponent.current?.open(employee.id)}}>Сменить пароль</Button>,
        isVisible: true,
        order: 10
      }]

      let userCols = [
        ...initialColumns
      ]
    
      if (hasPermission(Resource.Employees, Scope.Update)) {
        userCols = [
          ...userCols,
          ...addChangePassButtonCol
        ]
      }

    const { columns, pagination, filter, order } = useTable({
        initialColumns: userCols,
        key: EMPLOYEE_QUERY_KEY
    })

    const { data, isLoading } = useEmployeesQuery({
        Page: pagination.page,
        PageSize: pagination.pageSize,
        Filter: filter.filter,
        OrderBy: order.orderBy
    })

    const { filters } = useUsersFilters()

    const onAddHandler = () => {
        employeeComponent.current?.open()
    }

    const onRowClickHandler = (data: IEmployee) => {
        onEditHandler(data.id)
    }

    const onEditHandler = (id: string) => {
        employeeComponent.current?.open(id)
    }

    const onRemoveHandler = async (ids: Key[]) => {
        await deleteMutation.mutateAsync(ids.map((id) => id.toString()))
    }

    return (
        <>
            <EmployeeAddForm ref={employeeComponent} />
            <UserChangePasswordForm ref={userChangePasswordComponent} />
            <Table
                tableTitle="Сотрудники"
                dataSource={data?.response.data}
                columns={columns.data}
                rowKey="id"
                isLoading={isLoading}
                onUpdateColumns={columns.onColumnChange}
                pagination={{
                    currentPage: pagination.page,
                    pageSize: pagination.pageSize,
                    total: data?.response.count,
                    onPageChange: pagination.onPageChange,
                    onPageSizeChange: pagination.onPageSizeChange
                }}
                filters={{
                    filters: filters,
                    onSubmit: filter.onFilterChange,
                    onCancel: filter.onFilterReset,
                    filterKey: EMPLOYEE_QUERY_KEY
                }}
                onAdd={onAddHandler}
                addText="Добавить сотрудника"
                onEdit={onEditHandler}
                onRemove={onRemoveHandler}
                onRowClick={onRowClickHandler}
                onSorterChange={order.setOrderBy}
                permission={{
                    resource: Resource.Employees
                }}
            />
        </>
    )
}

export default EmployeesPage